import type { Plan } from '../types'

export function normalizePlan(row: any): Plan {
  const fx = row?.features || {}
  const list = Array.isArray(fx) ? fx : (Array.isArray(fx.list) ? fx.list : [])
  return {
    id: String(row.id ?? row.slug ?? ''),
    slug: String(row.slug ?? row.id ?? ''),
    name: String(row.name ?? ''),
    description: row.description ?? null,
    features: list,
    amount_cents: Number(row.amount_cents ?? fx.amount_cents ?? 0),
    currency: String(row.currency ?? fx.currency ?? 'BRL').toUpperCase(),
    interval: String(row.interval ?? fx.interval ?? 'month') as any,
    visible: Boolean(row.visible ?? fx.visible ?? true),
    active: Boolean(row.active ?? true),
    stripe_product_id: row.stripe_product_id ?? null,
    stripe_price_id: row.stripe_price_id ?? null,
    meta: !Array.isArray(fx) && typeof fx === 'object' ? fx : undefined,
  }
}
